import { E as EVENTS } from './events-58bc9098.js';

class ProductBlockVariantSelector extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      variantButton: "[js-variant-button]",
      variantGroup: "[js-variant-group-container]",
      variantLabelValue: "[js-variant-label-value]",
      variantOption: "[js-variant-option]",
      variantInput: "[js-variant-input]",
      noJsVariantSelector: "[js-no-js-variant-selector]",
    };
  }

  connectedCallback() {
    this.controller = new AbortController();

    console.log("[variant-selector] connected", this);

    this.initActiveVariants();

    this.addEventListener(
      EVENTS.PRODUCT_VARIANT_CHANGED,
      this.handleRepaint.bind(this),
      { signal: this.controller.signal },
    );
  }

  initActiveVariants() {
    this.activeVariantsController = new AbortController();

    this.noJsVariantSelector = this.querySelector(
      this.selectors.noJsVariantSelector,
    );
    this.noJsVariantSelector?.remove();

    this.variantInputs = this.querySelectorAll(this.selectors.variantInput);

    console.log(
      "[variant-selector] initActiveVariants inputs:",
      Array.from(this.variantInputs).map((input) => ({
        variantId: input.dataset.variantId,
        featuredMedia: input.dataset.optionValueFeaturedMedia,
        checked: input.checked,
        layout: input.dataset.variantLayout,
        value: input.value,
      })),
    );

    this.variantInputs.forEach((input) => {
      input.addEventListener("change", this.onVariantChange, {
        signal: this.activeVariantsController.signal,
      });

      input.addEventListener(
        "click",
        (event) => {
          console.log("[variant-selector] INPUT CLICK", {
            variantId: event.target.dataset.variantId,
            featuredMedia: event.target.dataset.optionValueFeaturedMedia,
            checked: event.target.checked,
            layout: event.target.dataset.variantLayout,
            value: event.target.value,
            target: event.target,
          });
        },
        { signal: this.activeVariantsController.signal },
      );
    });

    this.variantButton = this.querySelectorAll(this.selectors.variantButton);
    this.variantButton.forEach((button) => {
      button.addEventListener(
        "click",
        (event) => {
          console.log("[variant-selector] BUTTON CLICK", {
            value: event.currentTarget.dataset.value,
            button: event.currentTarget,
            parentLabel: event.currentTarget.closest("label"),
          });
        },
        {
          signal: this.activeVariantsController.signal,
        },
      );

      button.addEventListener(
        "keydown",
        (event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();

            const swatchButton = button.getAttribute("js-swatch");
            const chipButton = button.getAttribute("js-chip");

            console.log("[variant-selector] BUTTON KEYDOWN", {
              key: event.key,
              swatchButton,
              chipButton,
              button,
            });

            if (swatchButton !== null) {
              const swatchWrapper = event.target.parentElement;
              const inputHtml = swatchWrapper.previousElementSibling;

              this.onVariantChangeA11y(inputHtml);
            } else if (chipButton !== null) {
              this.onVariantChangeA11y(event.target.previousElementSibling);
            }
          }
        },
        {
          signal: this.activeVariantsController.signal,
        },
      );
    });
  }

  onVariantChange(event) {
    console.log("[variant-selector] CHANGE fired", {
      variantId: event.target.dataset.variantId,
      featuredMedia: event.target.dataset.optionValueFeaturedMedia,
      checked: event.target.checked,
      layout: event.target.dataset.variantLayout,
      value: event.target.value,
      target: event.target,
    });

    this.variantLayout = this.getAttribute("data-variant-layout");
    this.swatchOption = this.getAttribute("data-swatch-option");

    console.log("[variant-selector] current block attributes", {
      variantLayoutAttr: this.variantLayout,
      swatchOptionAttr: this.swatchOption,
      block: this,
    });

    switch (this.variantLayout) {
      case "chips":
        event.target.parentElement.parentElement
          .querySelector(".chip--selected")
          .classList.remove("chip--selected");

        event.target.parentElement
          .querySelector("[js-chip]")
          .classList.add("chip--selected");
        break

      case "swatches":
        event.target.parentElement.parentElement
          .querySelector(".swatch--selected")
          .classList.remove("swatch--selected");

        event.target.parentElement
          .querySelector("[js-swatch]")
          .classList.add("swatch--selected");
        break
    }

    let optionValueElement;
    if (this.variantLayout === "swatches" || this.variantLayout === "chips") {
      optionValueElement = event.target;
    } else if (this.variantLayout === "dropdown") {
      optionValueElement = event.target.selectedOptions[0];
    }

    const currentMainProductSection = this.closest("[js-product-section]");
    const productWithinQuickView =
      currentMainProductSection.dataset.sectionType === "quick-view-product";

    console.log("[variant-selector] dispatching PRODUCT_VARIANT_CHANGING", {
      variantId: optionValueElement?.dataset?.variantId,
      featuredMedia: optionValueElement?.dataset?.optionValueFeaturedMedia,
      withinQuickView: productWithinQuickView,
      section: currentMainProductSection,
    });

    const variantChangingEvent = new CustomEvent(
      EVENTS.PRODUCT_VARIANT_CHANGING,
      {
        bubbles: true,
        detail: {
          newOptionInput: optionValueElement,
          withinQuickView: productWithinQuickView,
        },
      },
    );

    currentMainProductSection.dispatchEvent(variantChangingEvent);
  }

  onVariantChangeA11y(inputHtml) {
    const currentMainProductSection = this.closest("[js-product-section]");
    const productWithinQuickView =
      currentMainProductSection.dataset.sectionType === "quick-view-product";

    console.log("[variant-selector] A11Y dispatch PRODUCT_VARIANT_CHANGING", {
      variantId: inputHtml?.dataset?.variantId,
      featuredMedia: inputHtml?.dataset?.optionValueFeaturedMedia,
      withinQuickView: productWithinQuickView,
    });

    const variantChangingEvent = new CustomEvent(
      EVENTS.PRODUCT_VARIANT_CHANGING,
      {
        bubbles: true,
        detail: {
          newOptionInput: inputHtml,
          withinQuickView: productWithinQuickView,
        },
      },
    );

    currentMainProductSection.dispatchEvent(variantChangingEvent);
  }

  handleRepaint() {
    console.log("[variant-selector] repaint");
    this.activeVariantsController.abort();
    this.initActiveVariants();
  }

  disconnectedCallback() {
    this.controller.abort();
  }
}

if (!customElements.get("product-block-variant-selector")) {
  customElements.define(
    "product-block-variant-selector",
    ProductBlockVariantSelector,
  );
}